import React, { Component } from "react";

class PrizeOnlyDraw extends Component {
  render() {
    const { title, date, draws } = this.props.event;
    return (
      <div>
        <div className="font-semibold text-2xl mb-2">{title}</div>
        <div className="font-light text-xs">DRAW DATE:</div>
        <div className="font-light text-base">{date}</div>
        <div className="jackpot">
          <div className="text-xl my-3 text-primary">
            <div className="font-bold text-5xl">
              {draws[0]['title']}
            </div>
          </div>
          {draws[0].number !== null && (
            <div className="block py-3 px-6">
              <div className={draws[0].winning_card ? "text-primary" : ""}>
                <div className="text-base mb-2">WINNING TICKET:</div>
                <div className="font-bold text-2xl mb-2">#{draws[0].number}</div>
                <span
                  
                  className="inline-block font-bold rounded"
                >
                  See all winners >
                  </span>
              </div>
            </div>
            )}
        </div>
      </div>
    );
  }
}

export default PrizeOnlyDraw;
